import { createRouter, createWebHistory } from "vue-router";

import modules from "./modules.js";

import { useSentry } from "@/composables/useSentry.ts";
import { useAuthStore } from "@/store/auth/index.ts";
import { ACCESS_TOKEN } from "@/utils/axios.ts";
import { ability, updateAbility } from "@/utils/casl/abilityFunctional.ts";
import { getHomeRouteForLoggedInUser } from "@/utils/routing.js";

const router = createRouter({
  history: createWebHistory(),
  routes: modules,
});

router.beforeEach(async (to, from, next) => {
  useSentry().setScope({
    tags: {
      from: from.meta.title as string,
      to: to.meta.title as string,
    },
  });
  const itemFromLocalStorage = localStorage.getItem(ACCESS_TOKEN);
  const authStore = useAuthStore();

  if (!itemFromLocalStorage?.length && to.meta.layout !== "auth") {
    return next("/login");
  }

  if (itemFromLocalStorage && !ability.rules.length) {
    try {
      await authStore.getMe().then((response) => {
        updateAbility(response.data?.ability);
      });
      if (from.path === "/login") {
        return next(getHomeRouteForLoggedInUser(authStore.user));
      }
    }
    catch (error) {
      console.log(error);
    }
  }

  const requiredAbility: any = to.meta.ability;

  if (
    requiredAbility
    && !ability.can(requiredAbility?.action, requiredAbility?.subject)
  ) {
    return next("/not-found");
  }

  next();
});

export default router;
